import React, { Component } from 'react';
import { Router, Route, Switch } from 'react-router-dom';
// import { renderRoutes } from 'react-router-config';
import './App.scss';
import _ from "lodash";
import {createBrowserHistory} from "history";
import getUserDetails from "./api/getUserDetails";

const loading = () => <div className="animated fadeIn pt-3 text-center">Loading... Please Wait</div>;
const history = createBrowserHistory();
// Containers
const location = window.location;
const DefaultLayout = React.lazy(() => import('./containers/DefaultLayout'));

// Pages
const Login = React.lazy(() => import('./views/Pages/Login'));
const Register = React.lazy(() => import('./views/Pages/Register'));
const Page401 = React.lazy(() => import('./views/Pages/Page401'));
const Page404 = React.lazy(() => import('./views/Pages/Page404'));
const Page500 = React.lazy(() => import('./views/Pages/Page500'));

class App extends Component {
  constructor(props, context) {
    super(props, context);
    let emp_id = window.localStorage.getItem('emp_id');
    let userDetail = {};

    this.state = {
      emp_id: emp_id,

      props: {
        userdetails: userDetail
      },
      loading: true
    };
    
    this._updateuserprops = this._updateuserprops.bind(this);
    
    if ((_.isEmpty(emp_id) || _.isEmpty(userDetail)) && window.location.pathname !== '/register') {
      history.push('/login');
    }
  }

  async componentDidMount() {
    let emp_id = window.localStorage.getItem('emp_id');
    if (!_.isEmpty(emp_id) && _.isEmpty(this.state.userdetails)) {
      let resp = await getUserDetails(emp_id); 
      if (resp) {
        if(resp.user_id && resp.username && resp.status === 'Active') {
          this.setState({props: {userdetails: resp}, loading: false});
          history.goBack();
        }
      }
    } else {
      this.setState({loading: false});
    }
  }

  _updateuserprops(data) {
    this.setState({
      props: {
        userdetails: data
      }
    }, () => {
      if (_.isEmpty(data)) {
        history.push('/');
        location.reload();
      } else {
        history.push('/dashboard');
      }
    });
  }

  async componentDidUpdate() {
    let { emp_id, props } = this.state;
    if (_.isEmpty(emp_id)) {
      if (_.isEmpty(props.userdetails)) {
        let resp = await getUserDetails();
        if (resp) {
          if(resp.user_id && resp.username && resp.status === 'Active') {
            this.setState({props: {userdetails: resp}, loading: false});
            history.goBack();
          }
        }
      }
      history.push('/login'); 
    }
  }

  render() {
    const { emp_id, props } = this.state;
    if (this.state.loading) {
      return loading();
    }

    return (
      <Router history={history}>
          <React.Suspense fallback={loading()}>
            <Switch>
              <Route exact path="/login" name="Login Page" render={routeProps => !emp_id
                ? <Login {...routeProps} {...props} _updateuserprops={props => {this._updateuserprops(props)}} />
                : <DefaultLayout {...routeProps} {...props} _updateuserprops={props => {this._updateuserprops(props)}}/>} 
              />
              <Route exact path="/register" name="Register Page" render={routeProps => <Register {...routeProps} {...props}/>} />
              <Route exact path="/401" name="Page 401" render={routeProps => <Page401 {...routeProps} {...props}/>} />
              <Route exact path="/404" name="Page 404" render={routeProps => <Page404 {...routeProps} {...props}/>} />
              <Route exact path="/500" name="Page 500" render={routeProps => <Page500 {...routeProps} {...props}/>} />
              <Route path="/" name="Home" render={routeProps => <DefaultLayout {...routeProps} {...props} _updateuserprops={props => {this._updateuserprops(props)}}/>} />
            </Switch>
          </React.Suspense>
      </Router>
    );
  }
}

export default App;
